export const CLIENT_TOKEN='clientToken';
export const REFRESH_TOKEN='refreshToken';
export const CADASTRE_KEY='cadastre';


/** WEBPACK FOOTER **
 ** ./src/SearchParameter.ts
 **/